import gql from 'graphql-tag'

export const DELETE_CREDENTIALS = gql`
  mutation DeleteCredentials {
    deleteCredentials {
      message
    }
  }
`
